export const state = () => ({
  url: null,
  ready: false,
  error: null,
});

export const mutations = {
  setUrl(state, url) {
    state.url = url || null;
    state.ready = !!url;
  },
  setError(state, err) {
    state.error = err ? String(err) : null;
  },
};
